import { PropsWithChildren, FC } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useExtractParams } from '@User/SignUpPage/logic'

import { getPreferredAppRedirectPath } from '~/redux-modules/preferences'
import { getUserIdentity } from '~/redux-modules/identity'
import { handleReturnTo } from '~/apps/routes/utils'

export const UnAuthRoute: FC<PropsWithChildren> = ({ children }) => {
    const { search: queryString, pathname: path } = useLocation()
    const identity = useSelector(getUserIdentity)
    const preferredRedirectPath = useSelector(getPreferredAppRedirectPath)
    const params = useExtractParams(queryString)

    if (identity?.id) {
        handleReturnTo({ path, params, queryString, preferredRedirectPath })
    }

    return <>{children}</>
}
